import cn from 'classnames';
import Image, { ImageProps } from 'next/image';
import React, { FC, useState } from 'react';

import { CloseOutlined as Cross } from '@ant-design/icons';

import s from './Bubble.module.css';

interface Props {
  closable?: boolean;
  image?: string | JSX.Element;
  onClick?: () => void;
  onClose?: () => void;
  className?: string;
  bounceOnLoad?: boolean;
  size?: 'small' | 'default';
  visible?: boolean;
}

const Bubble: FC<Props> = ({
  closable,
  image,
  onClick,
  onClose,
  className,
  bounceOnLoad,
  size = 'default',
  visible = true,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const renderImage = (element: JSX.Element): JSX.Element => {
    if (['Poster', 'Image'].includes(element.type?.name)) {
      return React.cloneElement<ImageProps>(element, {
        onLoadingComplete: () => setImageLoaded(true),
      });
    }
    if ((element as JSX.Element)?.props?.children) {
      return React.cloneElement(element as JSX.Element, {
        children: React.Children.map(element?.props?.children, (item) => renderImage(item)),
      });
    }
    return element;
  };

  return (
    <div
      className={cn(s.bubbleContainer, {
        [s.bounce]: imageLoaded && bounceOnLoad,
        [s.visible]: visible,
      })}
      onClick={onClick}
    >
      <div className={cn(s.bubble, s[size], className)}>
        {typeof image === 'string' ? (
          <Image
            src={image}
            onLoadingComplete={() => {
              setImageLoaded(true);
            }}
            alt=""
            fill
            className="object-cover"
          />
        ) : image ? (
          renderImage(image)
        ) : null}
      </div>
      {closable && (
        <div
          className={s.close}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose?.();
          }}
        >
          <Cross />
        </div>
      )}
    </div>
  );
};

export default Bubble;
